import React from 'react';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { BoxHeader } from '~/pages/Usuario/styles';
import {
  ActionInputMulti,
  ContainerMultiInputActions,
  LimiterInputWidth,
  MultiInputContainer,
  Wrap,
} from '~/styles/components';
import InputNoForm from '../InputNoForm';

export const IntervalFormMultiInput = ({
  tooltip,
  label = 'Intervalos',
  beginKeyName = 'start',
  endKeyName = 'end',
  intervals,
  setIntervals,
  isViewMode = false,
  isRequired = false,
}) => {
  // constante criada por não estar renderizando
  // os dados corretamente na tela ao remover
  const thisBeginKeyName = beginKeyName;
  const thisEndKeyName = endKeyName;

  const handleAddField = _ => {
    setIntervals(prevState => [
      ...prevState,
      { [thisBeginKeyName]: '', [thisEndKeyName]: '' },
    ]);
  };

  const handleChangeField = (index, event) => {
    const values = [...intervals];
    values[index][event.target.name] = event.target.value;
    setIntervals(values);
  };

  const handleRemoveField = index => {
    setIntervals(intervals.filter((_, idx) => idx !== index));
  };

  return (
    <MultiInputContainer>
      <BoxHeader style={{ justifyContent: 'normal' }}>
        <span className="boxText" style={{ color: '#828282' }}>
          {label}
        </span>
        {isRequired && (
          <span className="boxText" style={{ color: 'red' }}>
            *
          </span>
        )}
        {tooltip && (
          <button type="button" tooltip={tooltip} style={{ marginLeft: 5 }}>
            <BsFillQuestionCircleFill color="#4f4f4f" size={16} />
          </button>
        )}
      </BoxHeader>

      {intervals.map((inputField, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Wrap key={`${inputField}~${index}`}>
          <LimiterInputWidth w25>
            <InputNoForm
              type="number"
              placeholder="De"
              required={isRequired}
              name={thisBeginKeyName}
              value={inputField[thisBeginKeyName]}
              onChange={event => handleChangeField(index, event)}
              onWheelCapture={e => e.target.blur()}
              disabled={isViewMode}
            />
          </LimiterInputWidth>

          <LimiterInputWidth w25>
            <InputNoForm
              type="number"
              placeholder="Até"
              required={isRequired}
              name={thisEndKeyName}
              value={inputField[thisEndKeyName]}
              onChange={event => handleChangeField(index, event)}
              onWheelCapture={e => e.target.blur()}
              disabled={isViewMode}
            />
          </LimiterInputWidth>

          <ContainerMultiInputActions>
            {!isViewMode && (
              <>
                {intervals.length !== 1 && (
                  <ActionInputMulti
                    type="button"
                    onClick={() => handleRemoveField(index)}
                  >
                    <AiOutlineMinus color="#AAA" size={24} />
                  </ActionInputMulti>
                )}

                {intervals.length - 1 === index && (
                  <ActionInputMulti type="button" onClick={handleAddField}>
                    <AiOutlinePlus color="#AAA" size={24} />
                  </ActionInputMulti>
                )}
              </>
            )}
          </ContainerMultiInputActions>
        </Wrap>
      ))}
    </MultiInputContainer>
  );
};
